import { Actions, Effect } from "@ngrx/effects"; // Effect, Actions, toPayload
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { empty } from "rxjs/observable/empty";
import { Action, Store } from "@ngrx/store";
import * as QuestionnaireActions from "@zitelab/ionic-fhir-questionnaires";
import { AppState } from "../../models/app.state";
import { mergeMap } from "rxjs/operators/mergeMap";
import { withLatestFrom } from "rxjs/operators/withLatestFrom";

@Injectable()
export class QuestionnaireEffects {
  constructor(private action$: Actions, private store$: Store<AppState>) {}

  @Effect()
  update$: Observable<Action> = this.action$
    .ofType<QuestionnaireActions.UpdateAction>(QuestionnaireActions.UPDATE)
    .pipe(
      withLatestFrom(this.store$),
      mergeMap(([action, store]) => {
        console.log(action);
        return empty();
      })
    );
}



// WEBPACK FOOTER //
// ./src/app/store/effects/questionnaire.effects.ts